const ViewportHelper = {
  /**
   * Returns the absolute viewport position of an element in pixels
   * @param element
   * @returns {{x: Number, y: Number}}
   */
  getElementViewportPosition(element) {
    const scrollOffsets = this.getScrollOffsets();

    const top = element.getBoundingClientRect().top + scrollOffsets.y;
    const left = element.getBoundingClientRect().left + scrollOffsets.x;
    return {
      x: left,
      y: top
    };
  },
  /**
   * Returns the absolute viewport position of an event in pixels
   * @param event
   * @returns {{x: Number, y: Number}}
   */
  getViewportPosition(event) {
    if (event.pageX && event.pageY) {
      const scrollOffsets = this.getScrollOffsets();
      const top = event.pageY + scrollOffsets.y;
      const left = event.pageX + scrollOffsets.x;
      return {
        x: left,
        y: top
      };
    } else if (event.touches) {
      return {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    } else {
      console.error(
        "Cannot read pointer information from event: " + JSON.stringify(event)
      );
      return {
        x: 0,
        y: 0
      };
    }
  },
  getScrollOffsets() {
    const w = window;

    // This works for all browsers except IE versions 8 and before
    if (w.pageXOffset != null) return { x: w.pageXOffset, y: w.pageYOffset };
    // For IE (or any browser) in Standards mode
    const d = w.document;
    if (document.compatMode === "CSS1Compat")
      return {
        x: d.documentElement.scrollLeft,
        y: d.documentElement.scrollTop
      };
    // For browsers in Quirks mode
    return { x: d.body.scrollLeft, y: d.body.scrollTop };
  }
};

export { ViewportHelper };
